module.exports = __webpack_public_path__ + "img/3.c49eda7d.jpg";